<div class="organization-modal modal-content" piqetAngularDraggable>
  <div class="modal-header">
    <h1 class="modal-title ml-auto pl-5" id="exampleModalLabel">
      <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
    </h1>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body body-modal">
    <form [formGroup]="ingredientAddEditForm">
      <div class="row">
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="
                ingredientAddEditForm.get('ingredient')?.value ||
                ingredientAddEditForm.get('region')?.value ||
                ingredientAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Ingredient</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #ingredient
              [items]="ingredientList"
              [searchable]="false"
              bindLabel="name"
              formControlName="ingredient"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder=" Ingredient *"
              groupBy="childItems"
              bindValue="id"
              (change)="onChange($event)"
              [virtualScroll]="true"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="ingredient.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (ingredientAddEditForm.controls['ingredient']?.touched || submitted) &&
                ingredientAddEditForm.controls['ingredient']?.invalid
              "
              class="input-error"
            >
              Ingredient is required.
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="
                ingredientAddEditForm.get('ingredient')?.value ||
                ingredientAddEditForm.get('region')?.value ||
                ingredientAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Region</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #region
              [items]="regionData"
              [searchable]="false"
              bindLabel="name"
              formControlName="region"
              [readonly]="isDisabledDropDown"
              [searchFn]="commonInputSearch"
              placeholder="Region *"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="region.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
            <div
              *ngIf="
                (ingredientAddEditForm.controls['region']?.touched &&
                  ingredientAddEditForm.controls['region']?.invalid) ||
                ingredientAddEditForm.controls['region'].value?.name === '--Select Region-- ' ||
                (submitted && !ingredientAddEditForm.controls['region'].value?.name)
              "
              class="input-error"
            >
              Region is required.
            </div>
          </div>
        </div>
        <div class="col-sm-4">
          <div class="form-group required">
            <label
              *ngIf="
                ingredientAddEditForm.get('ingredient')?.value ||
                ingredientAddEditForm.get('region')?.value ||
                ingredientAddEditForm.get('organizationName')?.value
              "
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationList"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              [searchFn]="commonInputSearch"
              placeholder="All organization"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    placeholder="Search..."
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    (input)="organization.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="ingredientForm">
      <div class="row">
        <div class="col-sm-4" *ngFor="let formData of indicatorList">
          <div class="form-group required" aria-required="true">
            <div class="services-form">
              <input
                [formControlName]="formData.name"
                type="number"
                maxlength="30"
                class="input-custom-style"
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                placeholder="{{ formData.name }} ({{ formData.unit }})"
              />
              <label>{{ formData.name }} ({{ formData.unit }})</label>
              <div *ngIf="submitted && ingredientForm.get(formData.name)?.invalid">
                <div class="input-error">Default value is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="setButtonAndError text-margin">
        <div class="modal-footer">
          <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
          <button type="button" class="modelBtn purpleBtnHoverEffect" (click)="onSave()">
            Save
          </button>
        </div>

        <div
          class="redErrorTag"
          *ngIf="submitted && (this.ingredientAddEditForm.invalid || ingredientForm.invalid)"
        >
          <div class="bigScreenErrContain">
            <div>
              <span> <img src="./assets/icons/swalDeletion.svg" width="53" height="48" /></span>
            </div>
            <div>
              <div class="mb-3">
                <span>To proceed please complete the following fields : </span>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (ingredientAddEditForm.controls['ingredient']?.touched || submitted) &&
                    ingredientAddEditForm.controls['ingredient']?.invalid
                  "
                >
                  Ingredient
                </div>
              </div>
              <div class="topBottomCss">
                <div
                  *ngIf="
                    (ingredientAddEditForm.controls['region']?.touched &&
                      ingredientAddEditForm.controls['region']?.invalid) ||
                    ingredientAddEditForm.controls['region'].value?.name === '--Select region-- ' ||
                    (submitted && !ingredientAddEditForm.controls['region'].value?.name)
                  "
                >
                  Region
                </div>
              </div>
              <div class="topBottomCss" *ngIf="ingredientForm.invalid">
                <div>Default value</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
